/** localStorage for per-viewer conveniences only (theme, last environment). Never throws. */
export const prefs = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* private mode — the preference just doesn't persist */
    }
  },
};
